import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { VisibilitySettings } from '../menu/menuSliceTypes';

export interface Setting {
  visibilitySettings: VisibilitySettings;
}

const initialState: Setting = { visibilitySettings: {} };

export const settingSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setVisibilitySettings: (state, action: PayloadAction<any>) => {
      state.visibilitySettings = action.payload.visibilitySettings;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setVisibilitySettings } = settingSlice.actions;

export default settingSlice.reducer;
